const TagPicker = ({
  items,
  selectedIds,
  onToggle,
  search,
  onSearchChange,
  emptyLabel,
}) => {
  const filtered = items.filter((item) =>
    item.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="section-card">
      <div className="field">
        <label className="label">Buscar</label>
        <input
          className="input"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Digite para filtrar"
        />
      </div>
      <div className="tag-grid">
        {filtered.map((item) => (
          <button
            key={item.id}
            type="button"
            className={`tag ${selectedIds.includes(item.id) ? "tag--active" : ""}`}
            onClick={() => onToggle(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>
      {filtered.length === 0 ? <span className="muted">{emptyLabel}</span> : null}
    </div>
  );
};

export default TagPicker;
